import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import "../../../Sass/Common.scss";
// import { PrimaryDialogTitle } from "./DialogComponents";
import { ReactComponent as DeleteRoundIcon } from "Assets/Icons/DeleteRoundIcon.svg";
import { ReactComponent as Urgent } from "Assets/Icons/UrgencyIcon.svg";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { PrimaryDialogTitle } from "../Dialog/DialogComponents";

const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "20px",
  },
  iconStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#FBC14D",
    },
  },
  iconDeleteStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
  },
  rsAlertIcon: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#FBC14D",
      fillOpacity: "0.6",
    },
  },
  dialogWidth: {},
}));

const UpdatePaymentDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    handleSubmit = () => {},
    loading = false,
    type,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        maxWidth={"sm"}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle handleClose={handleClose} />
        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              marginBottom={"25px"}
            ></Box>
            <>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography variant="h3" medium>
                  {`Your current payment will be updates to ${type} !`}
                </Typography>
              </Box>
              {/* <Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <Typography variant="h4" regular>
                          {body}
                        </Typography>
                      </Box> */}
            </>
          </DialogContent>
        </Box>
        <DialogActions className={classes.dialogActionBtn}>
          <Button
            variant="contained"
            disabled={loading}
            startIcon={
              loading && <CircularProgress size="20px" color="white" />
            }
            onClick={() => handleSubmit()}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdatePaymentDialog;
